export default {
  regular: 400,
  medium: 500,
  semiBold: 600
};